export default __webpack_public_path__ + "static/media/Iconly-Bold-Setting.0f0578d2.svg";